import { _, Translatable } from "@icc/shared/helpers";
import { RollerDriveManual } from "./drive-manual";
import { RollerReceiver } from "./receiver";
import { RollerBlockHanger } from "./block-hanger";
import { RollerSecurityBolt } from "./security-bolt";

export type OutputType = 'tape' | 'cord' | 'cable' | null;

export class RollerDrive {
    id: number;
    driveId: number;
    receiverDriveId?: number;
    receiver?: RollerReceiver;
    @Translatable({ model: 'RollerShutterDrives', idField: 'driveId' })
    name: string;
    @Translatable({ model: 'RollerShutterDrives', idField: 'driveId' })
    shortName?: string;
    type: 'wired' | 'radio' | 'manual' | 'none' | 'hole';
    img: null | string;
    description: string;
    printCode: string;
    prices: RollerDrivePrices[];
    shutterTypes: number[];
    shutterId: number;
    default: boolean;
    linkedPrev: null | number;
    linkedNext: null | number;
    side: 'left' | 'right';
    driveOptionId: null | number;
    driveOptionChanged: boolean;
    selectedDriveControlOption: null | string;
    driveControlOptionChanged: boolean;
    manualDriveModelId: null | number;
    @Translatable({ model: 'RollerShutterDrivesManuals', idField: 'manualDriveModelId', field: 'name' })
    manualDriveModelName: null | string;
    manualDriveModelPrintCode: null | string;
    manualDriveModelChanged: boolean;
    hasDrive: boolean;
    availableOptions: string[];
    crankOutput: boolean;
    tapeOutput: boolean;
    cordOutput: boolean;
    cableOutput: boolean;
    emergencyLifting: boolean;
    /** Mechanizm sprężynowy - wymaga pancerza bez perforacji */
    isSpringMechanism: boolean;
    /** Czy cena wieszaka blokady WBZ jest wykluczona z ceny produktu (true = nie doliczana, false = doliczana) */
    wbzHangerInPrice: boolean;
    /** Wybrane wyjście sterowania (tape/cord/cable) */
    selectedOutput: number | null;
    @Translatable({ model: 'TapeCordOutputs', idField: 'selectedOutput', field: 'name' })
    selectedOutputName: string | null;
    selectedOutputCode: string | null;
    selectedOutputPrintCode: string | null;
    /** Typ wybranego wyjścia sterowania */
    outputType: OutputType;
    /** Wybrane wyjście korby */
    selectedCrankOutput: number | null;
    @Translatable({ model: 'TapeCordOutputs', idField: 'selectedCrankOutput', field: 'name' })
    selectedCrankOutputName: string | null;
    selectedCrankOutputCode: string | null;
    selectedCrankOutputPrintCode: string | null;
    /** Wybrany wieszak blokady (WBZ lub LPT) */
    blockHanger: RollerBlockHanger | null;
    /** Wybrany rygiel (automatyczny lub ręczny) */
    securityBolt: RollerSecurityBolt | null;
    errors: {
        invalidLength: boolean;
        invalidDrive: boolean;
        invalidDriveConnection: boolean;
    };
}

export interface IccRollerDrive {
    driveId: number;
    name: string;
    shortName?: string;
    type: 'wired' | 'radio' | 'manual' | 'none' | 'hole';
    img: null | string;
    description: string;
    printCode: string;
    prices: RollerDrivePrices[];
    shutterTypes: number[];
    availableOptions: string[];
    crankOutput: boolean;
    tapeOutput: boolean;
    cordOutput: boolean;
    cableOutput: boolean;
    emergencyLifting: boolean;
    /** Mechanizm sprężynowy - wymaga pancerza bez perforacji */
    isSpringMechanism: boolean;
    /** Czy cena wieszaka blokady WBZ jest wykluczona z ceny produktu (true = nie doliczana, false = doliczana) */
    wbzHangerInPrice: boolean;
}

export interface RollerDrivePrices {
    id: number;
    name: string;
    extId: string | null;
    minWidth: number;
    maxHeight: number;
    roundReelId: number | null;
    maxWeightWithoutHanger: number;
    maxWeightWithHanger: number;
    overload: boolean;
    engineWeight: number;
    /** Lista ID wymaganych akcesoriów (JSON array) */
    requiredAccessoriesIds: number[] | null;
    exclusions: number[];
    order: number;
    /** Grupy typów produktów, dla których wariant jest dostępny (null = dostępny dla wszystkich) */
    shutterTypeGroupIds?: number[] | null;
}

export interface DriveControlOption {
    key: string;
    label: string;
}

export const DRIVE_CONTROL_OPTIONS: Record<string, string> = {
    'none_option': _('SHUTTER_DRIVE|Brak opcji'),
    'automatic_bolts': _('SHUTTER_DRIVE|Rygle automatyczne'),
    'manual_latches': _('SHUTTER_DRIVE|Zasuwki ręczne'),
    'espagnolette_lock': _('SHUTTER_DRIVE|Zamek baskwilowy'),
    'block_hanger_wbz': _('SHUTTER_DRIVE|Wieszak blokady [WBZ]'),
    'blocking_hanger_lpt': _('SHUTTER_DRIVE|Wieszak blokujący [LPT]')
};
